import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgModule} from '@angular/core';

import { PopoverModule, WavesModule } from 'angular-bootstrap-md';

import {ApiDetailComponent} from './api-detail/api-detail.component';
import {ApisComponent} from './apis/apis.component';
import {ApisFilterPipe} from './apis/apis-filter.pipe';
import {ApisRoutingModule} from './apis-routing.module';
import {ApplicationKeysComponent} from './application-keys/application-keys.component';
import {SubscriptionManageComponent} from './subscription-manage/subscription-manage.component';
import {SubscriptionsComponent} from './subscriptions/subscriptions.component';

@NgModule({
  declarations: [
    ApiDetailComponent,
    ApisComponent,
    ApisFilterPipe,
    ApplicationKeysComponent,
    SubscriptionManageComponent,
    SubscriptionsComponent,
  ],
  imports: [
    ApisRoutingModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    PopoverModule.forRoot(),
    WavesModule.forRoot(),
  ]
})
export class ApisModule {
}
